import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, AbstractControl, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import * as _ from 'lodash';
import { VideoCommentService, AuthenticationService } from '../../../../services';
import { Comment } from '../../../../models';

@Component({
  selector: 'comment-modal',
  styleUrls: [('./commentModal.component.scss')],
  templateUrl: './commentModal.component.html'
})

export class CommentModal implements OnInit, AfterViewChecked {

  public oldF: FormGroup;
  public form: FormGroup;
  public submitted: boolean = false;
  public loading = false;
  public error = '';
  public editdata: Comment;

  modalHeader: string;
  modalContent: string = `Lorem ipsum dolor sit amet,
   consectetuer adipiscing elit, sed diam nonummy
   nibh euismod tincidunt ut laoreet dolore magna aliquam
   erat volutpat. Ut wisi enim ad minim veniam, quis
   nostrud exerci tation ullamcorper suscipit lobortis
   nisl ut aliquip ex ea commodo consequat.`;

  constructor(
    private activeModal: NgbActiveModal,
    fb: FormBuilder,
    private service: VideoCommentService,
    private auth: AuthenticationService,
    private toasterService: ToasterService
  ) {
    console.log('CALL > CommentModal > constructor');
    this.form = fb.group({
      comment_id: [null],
      comment_type: ['1', Validators.compose([Validators.required])],
      comment_text: [null, Validators.compose([Validators.required])],
      user_id: [null, Validators.compose([Validators.required])],
      video_id: [null, Validators.compose([Validators.required])],
      status: [1, Validators.required]
    });
    // this.form.reset();
  }

  ngOnInit() { }

  ngAfterViewChecked() {
    this.formChanged();
  }

  formChanged() {
    if (this.form === this.oldF) { return; }
    this.oldF = this.form;
    if (this.oldF) {
      this.oldF.valueChanges.subscribe(data => {
        // console.log('this.form.valueChanges -> data', data);
        for (const field in data) {
          const control = this.oldF.get(field);
          if (control && !control.valid) {
            console.log('field ', field, ' -> ', control.errors);
          }
        }
      });
    }
  }

  setData(editdata: Comment) {
    this.editdata = editdata;
    this.form.patchValue(this.editdata);
  }

  onSubmit(value: any) {
    console.log('onSubmit > value > ', value);
    let save = (value.comment_id)
      ? this.service.edit(value.comment_id, value)
      : this.service.add(value);

    save
      .subscribe((res: any) => {
        console.log('res', res);
        if (res && res.result && res.result.entity && res.result.inserted_id) {
          value = _.assignIn(value, res.result.entity, { comment_id: res.result.inserted_id });
        }
        this.activeModal.close(value);
        this.toasterService.pop('success', '', 'Successfully Saved');
      },
      (err) => {
        this.toasterService.pop('error', '', 'Error in save. Please try after some time.');
      });

  }

  closeModal() {
    this.activeModal.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/shared/components/commentModal/commentModal.component.ts